import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	virtualServiceAgent: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.virtual-service-agent',
		defaultMessage: 'Virtual service agent',
		description: 'Settings navigation section title for a service project',
	},
	intents: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.intents',
		defaultMessage: 'Intents',
		description: 'Settings navigation menu link for a service project',
	},
	standardFlows: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.standard-flows',
		defaultMessage: 'Standard flows',
		description: 'Settings navigation menu link for a service project',
	},
	conversations: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.conversations',
		defaultMessage: 'Conversations',
		description: 'Settings navigation menu link for a service project',
	},
	settings: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.settings',
		defaultMessage: 'Settings',
		description: 'Settings navigation menu link for a service project',
	},
	test: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.test',
		defaultMessage: 'Test',
		description: 'A navigation menu link that opens a new tab to test the virtual service agent',
	},
	virtualAgentLozengeText: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.virtual-agent-lozenge-text',
		defaultMessage: 'New',
		description: 'Lozenge text next to navigation menu item for service project',
	},
	title: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.title',
		defaultMessage: 'Virtual service agent',
		description: 'Title for virtual service agent navigation panel',
	},
	aiAnswers: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.ai-answers',
		defaultMessage: 'AI answers',
		description: 'AI answers navigation menu link for a service project',
	},
	performance: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.performance',
		defaultMessage: 'Performance',
		description: 'Performance navigation menu link for a service project',
	},
});
